module.exports = __webpack_public_path__ + "img/sam.fa16c4e7.jpg";